<template>
    <section>
        <form @submit.prevent="confirm">
            <h2 class="title pink">Privacy</h2>
            <hr />
            <div class="row">
                <div class="col">
                    <p>
                    Dear {{ fullName }},<br/>
                    With reference to processing personal data, below we provide you with some information that it is necessary to bring to your knowledge in order to comply with legal obligations and because transparency and correctness towards you is a fundamental part of our business.
                    </p>
                    <p>
                    Open the attached document to obtain the privacy information in accordance with art. 14 and 13 of EU Regulation 679/2016 (GDPR).
                    </p> 
                </div>
            </div>
            <hr/>
            <div class="form-group">
                <b-form-checkbox
                    id="privacy_1"
                    v-model="form.privacy_1"
                    name="privacy_1"
                    value="accepted"
                    unchecked-value="not_accepted"
                    :class="{ 'is-invalid': $v.form.privacy_1.$error }"
                    :state="validateState('privacy_1')"
                    >
                    I declare to have duly read and understood the information provided by {{ this.$strings.us }}. 
                    in accordance with art. 13 of EU Regulation 2016/679 (GDPR), 
                    visible and downloadable <download what="privacy_1"/><br/>
                    <i>(mandatory for the purposes of managing the Ins4Models insurance program)</i>
                </b-form-checkbox>
                <div class="invalid-feedback" v-if="!$v.form.privacy_1.required">* you need to accept to continue</div>
            </div>
            <hr />
            <div class="form-group">
                <b-form-checkbox
                    id="privacy_axa"
                    v-model="form.privacy_axa"
                    name="privacy_axa"
                    value="accepted"
                    unchecked-value="not_accepted"
                    :class="{ 'is-invalid': $v.form.privacy_axa.$error }"
                    :state="validateState('privacy_axa')"
                    >
                    I declare to have duly read and understood the information provided by {{ this.$strings.partner }} 
                    in accordance with art. 13 and art. 14 of EU Regulation 2016/679 (GDPR), 
                    visible and downloadable <download what="privacy_axa"/><br/>
                    <i>(mandatory for the management of the Ins4Models insurance program)</i>               
                </b-form-checkbox>
                <div class="invalid-feedback" v-if="!$v.form.privacy_axa.required">* you need to accept to continue</div>
            </div>
            <hr />
            <div class="form-group">
                <b-form-checkbox
                    id="privacy_marketing"
                    v-model="form.privacy_marketing"
                    name="privacy_marketing"
                    value="accepted"
                    unchecked-value="not_accepted"
                    >
                    I also express my consent to the processing of my data for the sending of communications and newsletters, 
                    through automated contact methods (such as e-mail, sms, mms) and traditional methods 
                    (such as telephone calls with operator and traditional mail) related to other 
                    products and services insurance and satisfaction surveys.
                </b-form-checkbox>
            </div>
            <hr />
            <div class="row-btn">
                <button type="submit" class="btn btn-primary">Next</button>
            </div>
        </form>
    </section>                
</template>

<script>
//import { required } from 'vuelidate/lib/validators'

export default {
    data: function () {
        return {
            form: {
                privacy_1: "not_accepted",
                privacy_axa: "not_accepted",
                privacy_marketing: "not_accepted",
            }            
        }
    },
    validations: {
        form: {
            privacy_1: {
                checked: value => value == 'accepted',
            },
            privacy_axa: {
                checked: value => value == 'accepted',
            },
        }
    },
    created() {
        this.$emit('set-style', '');
        this.$emit('set-bg-classes', 'bg');
        this.$emit('set-container-classes', 'col-12 col-md-8');
        this.$emit('set-small-logo');
    }, 
    computed: {
        fullName(){
            return this.$store.state.userInfo.name
        }
    },
    methods: {
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty && $error==true ? !$error : null;
        },
        confirm: function(){

            this.$v.$touch()
            if (this.$v.$invalid) {
                return false;
            }

            this.$store.dispatch('acceptPrivacy', { ...this.form })
                .then(() => {
                    if(this.$store.getters.privacyCgaAccepted){
                        this.$router.push('/')
                    } else {
                        this.$router.push('/privacy/cga');
                    }                    
                })
                .catch(() => {
                    //console.log(err);
                });
        }
    }
}
</script>